import {
  WORKFLOW_EMAIL_WAIT_OPTIONS,
  WORKFLOW_SMS_WAIT_OPTIONS,
  WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WORKFLOW_WAIT_ERROR_MAX_DAYS,
  WORKFLOW_WAIT_ERROR_MAX_DAYS_LABEL,
  WORKFLOW_WAIT_ERROR_POSITION,
  WORKFLOW_WAIT_ERROR_POSITION_LABEL,
  WORKFLOW_WAIT_ERROR_REQUIRED_LABEL,
  WORKFLOW_WAIT_ERROR_REQUIRED_VALUE,
  WORKFLOW_WAIT_ERROR_REQUIRED_WAIT,
  WORKFLOW_WAIT_ERROR_WRONG_FORMAT,
  WORKFLOW_WAIT_ERROR_WRONG_FORMAT_LABEL,
  WORKFLOW_WAIT_TYPE_MODE_EMAIL,
  WORKFLOW_WAIT_TYPE_MODE_SMS
} from 'Constants/'
import {
  ACTION_BUTTON_TYPE_DELETE,
  ButtonAction,
  Grid,
  GridCell,
  INPUT_TEXT_VARIANT_DANGER,
  LINK_VARIANT_HIGHLIGHT,
  Select
} from 'mailup-web-components'
import { workflowWaitSelector } from 'Pages/Workflow/recoil/state/data'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import * as S from './WorkflowBuilder.styles'

const WaitItem = ({
  draggableId,
  itemError,
  onDelete,
  onChange,
  setSteps,
  currentDragItem,
  canDelete,
  toggleDisabled,
  waitTypeDisabled
}) => {
  const intl = useIntl()

  const { WaitType, Value, ValueType, mode, isDirty } = useRecoilValue(
    workflowWaitSelector(draggableId)
  )

  useEffect(() => {
    if (
      Number.isInteger(WaitType) &&
      WaitType >= 0 &&
      ((mode === WORKFLOW_WAIT_TYPE_MODE_EMAIL &&
        !WORKFLOW_EMAIL_WAIT_OPTIONS.some(({ value }) => value === WaitType)) ||
        (mode === WORKFLOW_WAIT_TYPE_MODE_SMS &&
          !WORKFLOW_SMS_WAIT_OPTIONS.some(({ value }) => value === WaitType)))
    ) {
      onChange(draggableId, {
        actionType: 'change_wait_type',
        payload: {
          value: undefined,
          mode,
          isDirty
        }
      })
    }
  }, [mode, WaitType])

  const handleDelete = () => {
    onDelete(draggableId)
  }

  const toggleDaysHours = () => {
    const data = {
      value: Value,
      valueType: ValueType,
      waitType: WaitType,
      mode
    }
    onChange(draggableId, {
      actionType: 'toggle_value_type',
      payload: data
    })
  }

  const handleChangeValue = ({ target: { value } }) => {
    const data = {
      value,
      valueType: ValueType,
      waitType: WaitType,
      mode
    }
    onChange(draggableId, {
      actionType: 'change_value',
      payload: data
    })
  }

  const handleChangeWaitType = (value) => {
    const data = {
      value,
      mode
    }
    onChange(draggableId, {
      actionType: 'change_wait_type',
      payload: data
    })
  }

  const renderErrorMsg = (errorType) => {
    switch (errorType) {
      case WORKFLOW_WAIT_ERROR_REQUIRED_VALUE:
        return intl.formatMessage({
          id: WORKFLOW_WAIT_ERROR_REQUIRED_LABEL
        })
      case WORKFLOW_WAIT_ERROR_REQUIRED_WAIT:
        return intl.formatMessage({
          id: WORKFLOW_WAIT_ERROR_REQUIRED_LABEL
        })
      case WORKFLOW_WAIT_ERROR_WRONG_FORMAT:
        return intl.formatMessage({
          id: WORKFLOW_WAIT_ERROR_WRONG_FORMAT_LABEL
        })
      case WORKFLOW_WAIT_ERROR_MAX_DAYS:
        return intl.formatMessage({
          id: WORKFLOW_WAIT_ERROR_MAX_DAYS_LABEL
        })
      case WORKFLOW_WAIT_ERROR_POSITION:
        return intl.formatMessage({
          id: WORKFLOW_WAIT_ERROR_POSITION_LABEL
        })
    }
  }

  const makeOptionFromLabel = ({ label, value }) => ({
    label: intl.formatMessage({ id: label }),
    value
  })
  const optsSelect =
    mode === WORKFLOW_WAIT_TYPE_MODE_EMAIL
      ? WORKFLOW_EMAIL_WAIT_OPTIONS.map(makeOptionFromLabel)
      : WORKFLOW_SMS_WAIT_OPTIONS.map(makeOptionFromLabel)

  return (
    <S.InnerItem>
      {currentDragItem !== draggableId && <S.ItemHorizontalLine />}
      <S.ItemCircle>
        {currentDragItem !== draggableId && <S.Circle error={!!itemError} />}
      </S.ItemCircle>
      <S.WorkflowBuilderItem>
        <S.ItemLeft>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.DragElementWaitTypeWait'
          })}
        </S.ItemLeft>
        <S.ItemRightB withInputs>
          <Grid cols={12}>
            <GridCell span={3}>
              <S.Input
                id={`time-${draggableId}`}
                onChange={handleChangeValue}
                value={Value}
                maxlength={3}
                variant={
                  (itemError === WORKFLOW_WAIT_ERROR_REQUIRED_VALUE ||
                    itemError === WORKFLOW_WAIT_ERROR_WRONG_FORMAT ||
                    itemError === WORKFLOW_WAIT_ERROR_MAX_DAYS) &&
                  INPUT_TEXT_VARIANT_DANGER
                }
              />
            </GridCell>
            <GridCell span={2}>
              <S.LinkBold
                variant={LINK_VARIANT_HIGHLIGHT}
                firstOf2Line
                center
                onClick={toggleDaysHours}
                disabled={toggleDisabled}
              >
                {ValueType === WORKFLOW_STEP_VALUE_TYPE_DAYS
                  ? intl.formatMessage({
                      id: 'Load.AutomationWorkflow.DragElementWaitUnitDays'
                    })
                  : intl.formatMessage({
                      id: 'Load.AutomationWorkflow.DragElementWaitUnitHours'
                    })}
              </S.LinkBold>
            </GridCell>
            <GridCell span={7}>
              <Select
                disabled={waitTypeDisabled}
                value={WaitType}
                options={optsSelect}
                data-mu-test='select-wait'
                placeholder={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DragElementWaitAfterPlaceholder'
                })}
                onChange={handleChangeWaitType}
                searchable={false}
                error={itemError === WORKFLOW_WAIT_ERROR_REQUIRED_WAIT}
              />
            </GridCell>
          </Grid>
          {itemError && (
            <S.MsgError itemError={itemError}>
              {renderErrorMsg(itemError)}
            </S.MsgError>
          )}
        </S.ItemRightB>
        {canDelete && (
          <S.ItemActionsB withGhostActions>
            <div className='ghost'>
              <ButtonAction
                type={ACTION_BUTTON_TYPE_DELETE}
                onClick={handleDelete}
              />
            </div>
          </S.ItemActionsB>
        )}
      </S.WorkflowBuilderItem>
    </S.InnerItem>
  )
}

WaitItem.propTypes = {
  draggableId: PropTypes.string,
  itemError: PropTypes.string,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  setSteps: PropTypes.func,
  currentDragItem: PropTypes.string,
  canDelete: PropTypes.bool,
  toggleDisabled: PropTypes.bool,
  waitTypeDisabled: PropTypes.bool
}

export default WaitItem

/*

WaitType: after qualcosa.... (choose a wait option)
Value: input hours o days
ValueType: 0: days, 1: hours

*/
